import DBG from "./DBG";
import moment from "moment";
import GlobalSettings from "./GlobalSettings";
export default class Task {
    toString() {
        return `Task[${this.guid}] Name=${this.name}, start=${this.startDate}, end=${this.endDate}, sector=(${this.startSector}), type=(${this.taskType})`;
    }
    static ReadData(taskGuid) {
        DBG.log("Task - reading data for:", taskGuid, GlobalSettings.settings.sectorStart, GlobalSettings.settings.sectorEnd);
        let prom = new Promise((resolve, reject) => {
            let res = new Task();
            res.guid = taskGuid;
            let promises = [];
            promises.push(this.GetFieldWithRetry(taskGuid, Office.ProjectTaskFields.Start));
            promises.push(this.GetFieldWithRetry(taskGuid, Office.ProjectTaskFields.Finish));
            promises.push(this.GetFieldWithRetry(taskGuid, Office.ProjectTaskFields.Name));
            let fieldProjectStart = GlobalSettings.numericFields.find(x => x.id == GlobalSettings.settings.sectorStart).field;
            promises.push(this.GetFieldWithRetry(taskGuid, fieldProjectStart));
            promises.push(this.GetFieldWithRetry(taskGuid, Office.ProjectTaskFields.Text10));
            if (GlobalSettings.usingSectorEnd()) {
                let fieldProjectEnd = GlobalSettings.numericFields.find(x => x.id == GlobalSettings.settings.sectorEnd).field;
                promises.push(this.GetFieldWithRetry(taskGuid, fieldProjectEnd));
            }
            Promise.all(promises).then((values) => {
                res.startDate = new Date(moment(values[0], "ddd DD/MM/YYYY").valueOf());
                res.endDate = new Date(moment(values[1], "ddd DD/MM/YYYY").valueOf());
                res.name = values[2];
                res.startSector = values[3];
                res.taskType = values[4];
                if (GlobalSettings.usingSectorEnd()) {
                    res.endSector = values[5];
                }
                resolve(res);
            }).catch(reason => {
                reject(reason);
            });
        });
        return prom;
    }
    static GetFieldWithRetry(taskGuid, fieldId) {
        DBG.log("Task - GetFieldWithRetry", taskGuid, fieldId);
        let res = new Promise((resolve, reject) => {
            setTimeout(() => {
                Office.context.document.getTaskFieldAsync(taskGuid, fieldId, (result) => {
                    if (result.status === Office.AsyncResultStatus.Succeeded) {
                        DBG.log(`Task ${taskGuid} field: ${fieldId}: ${result.value.fieldValue}`, result);
                        resolve(result.value.fieldValue);
                    }
                    else {
                        DBG.log(`Task ${taskGuid} field: ${fieldId} - attempt #2`, result);
                        setTimeout(() => {
                            Office.context.document.getTaskFieldAsync(taskGuid, fieldId, (result) => {
                                if (result.status === Office.AsyncResultStatus.Succeeded) {
                                    DBG.log(`Task ${taskGuid} field: ${fieldId}: ${result.value.fieldValue}`, result);
                                    resolve(result.value.fieldValue);
                                }
                                else {
                                    reject(result);
                                }
                            });
                        }, 100);
                    }
                });
            }, 1);
        });
        return res;
    }
}
